export enum EMFOScrollEventBlockId {
  benefits = 'benefits',
  form = 'agent-form',
  calculation = 'calculation',
}
